// extracted by mini-css-extract-plugin
module.exports = {"main":"science-hero-module--main--1Vgmx","heroImage":"science-hero-module--hero-image--3CYiW","wave":"science-hero-module--wave--2J1ox","dna":"science-hero-module--dna--1K92M"};